<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <b-form-group :label-cols="5" label="Name" :state="stateForField('name')" :invalid-feedback="errorForField('name')" label-class="text-right">
            <b-form-input v-model="ascFeeSchedule.name"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Effective Date" :state="stateForField('effectiveDate')" :invalid-feedback="errorForField('effectiveDate')" label-class="text-right">
            <b-form-datepicker format="MM/dd/yyyy" :use-utc="true" :typeable="true" class="form-control datepicker" v-model="ascFeeSchedule.effectiveDate"></b-form-datepicker>
          </b-form-group>
          <b-form-group :label-cols="5" label="Discount Strategy" :state="stateForField('discountStrategy')" :invalid-feedback="errorForField('discountStrategy')" label-class="text-right">
            <b-select class="input-border" v-model="ascFeeSchedule.discountStrategy" :options="discountStrategyOptions"></b-select>
          </b-form-group>
          <b-form-group :label-cols="5" label="Self Pay" :state="stateForField('selfPay')" :invalid-feedback="errorForField('selfPay')" label-class="text-right">
            <b-form-radio-group v-model="ascFeeSchedule.isSelfPay" class="pt-2" :options="yesNoOptions"/>
          </b-form-group>

          <b-form-group v-show="!ascFeeSchedule.organizationAscFeeScheduleId" :label-cols="5" label="ASC Location" :state="stateForField('ascLocation')" :invalid-feedback="errorForField('ascLocation')" label-class="text-right">
            <b-select class="input-border" v-model="ascFeeSchedule.organizationId" :options="ascLocationOptions"></b-select>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveFeeSchedule()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import api from '../services/api'
  import _ from 'lodash'
  import ErrorsMixin from '@/mixins/ErrorsMixin'

  export default {
    name: 'AscFeeSchedulesModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editAscFeeSchedule: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        ascFeeSchedule: {},
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        isSaving: false,
        ascLocationOptions: [{ value: null, text: 'Click to select' }],
        discountStrategyOptions: [
          { value: null, text: '100%' },
          { value: 'FirstFull50Remaining', text: '100% 50%' },
          { value: 'FirstFullSecondAt50ThenZero', text: '100% 50% 0%' },
          { value: 'Discount25EachToZero', text: '100% 50% 25% 0%' },
          { value: 'Discount25Each', text: '100% 50% 25%' },
          { value: 'All60', text: '60%' },
          { value: 'Discount25EachWithDouble25', text: '100% 50% 25% 25% 0%' },
          { value: 'FirstFull2At50ThenZero', text: '100% 50% 50% 0%' }
        ]
      }
    },

    watch: {
      editAscFeeSchedule (newValue) {
        if (newValue) {
          this.ascFeeSchedule = _.clone(newValue)
        } else {
          this.ascFeeSchedule = {}
        }
      }
    },

    computed: {
      title () {
        if (this.ascFeeSchedule && this.ascFeeSchedule.organizationAscFeeScheduleId) {
          return 'Edit Facility Fee Schedule'
        }
        return 'Create Facility Fee Schedule'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.ascFeeSchedule.name) {
          this.addErrorForField('name', 'You must enter a name')
        }

        if (!this.ascFeeSchedule.organizationId) {
          this.addErrorForField('ascLocation', 'You must choose a location')
        }

        if (this.ascFeeSchedule.isSelfPay === null) {
          this.addErrorForField('selfPay', 'You must choose a self pay option')
        }

        return !this.hasErrors()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      saveFeeSchedule () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        this.isSaving = true
        api.post('Dashboard/AscFeeSchedules', this.ascFeeSchedule).then(response => {

          this.isSaving = false
          this.$emit('updated', response)
          this.editing = false
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
        this.editing = false
      },

      loadAscLocations () {
        this.isSaving = false
        api.get('Dashboard/AscLocations').then(response => {
          response.data.forEach(location => {
            this.ascLocationOptions.push({
              value: location.ascOrganizationId, text: location.name
            })
          })
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    },
    created () {
      this.loadAscLocations()
    }
  }
</script>
